<div class="mb-3 row">
  <label class="col-sm-4 col-form-label">All day</label>
  <div class="col-sm-8">
    <label>
      <input type="radio" name="allDay" [checked]="isAllDay()" (click)="setToAllDay()"> Yes
    </label>
    <label class="ms-2">
      <input type="radio" name="allDay" [checked]="!isAllDay()" (click)="setDefaultTimes()"> No
    </label>
  </div>
</div>

@if (!isAllDay()) {
  <div class="mb-3">
    <div class="row">
      <label class="col-sm-4 col-form-label">Between</label>
      <ngb-timepicker
              class="col-sm-4"
              id="startTime"
              [minuteStep]="15"
              [formField]="fields().startTime">
      </ngb-timepicker>
      <ngb-timepicker
              class="col-sm-4"
              id="endTime"
              [minuteStep]="15"
              [formField]="fields().endTime">
      </ngb-timepicker>
    </div>
    @if (fields().startTime().invalid() && fields().startTime().touched()) {
      <div class="form-error-message">
        @if (fields().startTime().errors()?.kind === 'required') {
          <p>Start time is required</p>
        }
        @if (fields().startTime().errors()?.kind === 'pattern') {
          <p>Start time must be in 15 minutes increments</p>
        }
      </div>
    }
    @if (fields().endTime().invalid() && fields().endTime().touched()) {
      <div class="form-error-message">
        @if (fields().endTime().errors()?.kind === 'required') {
          <p>End time is required</p>
        }
        @if (fields().endTime().errors()?.kind === 'pattern') {
          <p>End time must be in 15 minutes increments</p>
        }
      </div>
    }
  </div>
}
@if (fields().endTime().errors()?.kind === 'startTimeIsAfterEndTime') {
  <div class="form-error-message">
    <p>Start time must be earlier than end time</p>
  </div>
}

<div class="mb-3 row">
  <label for="reason" class="col-sm-4 col-form-label">Reason</label>
  <div class="col-sm-8">
    <textarea class="form-control" id="reason" [formField]="fields().reason"></textarea>
  </div>
</div>
@if (fields().reason().invalid() && fields().reason().touched()) {
  <div class="form-error-message">
    @if (fields().reason().errors()?.kind === 'required') {
      <p>Reason is required</p>
    }
  </div>
}